// WarmCompanionCareSection.js
import React from 'react';
import { Phone } from 'lucide-react';
import companionCareImage from '../assets/warm-companion-care-image.jpg';

const WarmCompanionCareSection = () => {
  return (
    <section className="bg-white py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">

          {/* Left Content */}
          <div>
            <p className="text-primary text-xs md:text-sm font-medium tracking-[0.22em] uppercase mb-5">
              Companion Care
            </p>
            <h2 className="font-display font-light text-ink leading-[1.1] text-3xl md:text-4xl lg:text-5xl mb-6">
              Warm, Compassionate Companion Care for Older People at Home
            </h2>

            <div className="space-y-4 text-muted text-base leading-relaxed mb-10 max-w-lg">
              <p>
                At Wei Care, we know that companionship is{' '}
                <span className="text-primary font-medium">essential</span> to a happy, healthy life. Our companion care goes beyond practical help, offering genuine connection and social engagement for older people who may feel isolated. We believe no one should feel alone, so our carers are there with a friendly face, a listening ear, and a helping hand.
              </p>

              <p>
                Companion care is a non-medical, in-home service centred on the social and emotional wellbeing of older people. It helps ease the loneliness and isolation that can come with age, especially for those living on their own. Our carers become trusted friends, sharing conversation, hobbies, and activities that keep minds active and spirits lifted.
              </p>
            </div>

            <a
              href="tel:+61480804640"
              className="inline-flex items-center gap-2 bg-primary hover:bg-primary-dark text-white font-medium text-sm px-7 py-3.5 rounded-full transition-colors"
            >
              <Phone size={16} />
              Call +61 420 162 243
            </a>
          </div>

          {/* Right Image */}
          <div className="relative">
            <img
              src={companionCareImage}
              alt="A younger woman embracing an older woman outdoors"
              className="w-full h-[420px] lg:h-[560px] object-cover rounded-2xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default WarmCompanionCareSection;
